import { createSlice } from '@reduxjs/toolkit';
import { fetchGuidelines } from './Utils/GuidelineUtils';

const initialState = {
  data: {},
  detail: {},
  isLoading: false,
};

const guidelineSlice = createSlice(
  {
    name: 'guideline',
    initialState: initialState,
    reducers: {
      setDetail: (state, action) => {
        state.detail = action.payload;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchGuidelines.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(fetchGuidelines.fulfilled, (state, action) => {
          state.isLoading = false;
          state.data = action.payload;
        })
        .addCase(fetchGuidelines.rejected, (state, action) => {
          state.isLoading = false;
          console.log(action.error.message, "error action")
        })
    }
  }
);

export const { setDetail } = guidelineSlice.actions;

export default guidelineSlice.reducer;